import { Dialog, Icon, Icons, Intent } from "construct-ui";
import moment from "moment";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import FileUploadInputComponent from "../../../components/file/file-upload-input.component";
import SelectUserComponent from "../../../components/user/select-user.component";
import { formats } from "../../../config/constants";
import goodMovementModel from "../../../models/posm/goods-movement.model";
import ViewBase from "../../view-base.view";
import RetailQtyExcelUpload from "./retail-qty-upload.view";
import loginModel from "../../../models/login.model";
import { saveApplication } from "../../../models/posm/posm-goods-issue-application.model";
import { APPROVAL_STATUSES } from "./posm-goods-issue-application.view";

function CreatePOSMGoodsIssueApplicationDialog() {
  ViewBase.call(this);

  const ACTIONS = {
    SUBMIT: APPROVAL_STATUSES.PendingApproval.code,
    SAVE: APPROVAL_STATUSES.PendingSubmission.code
  }
  const DEFAULT_MOVEMENT_DETAIL_INFO = {
    Warehouse: null,
    Storage: null,
    Applicant: null,
    movementBy: null,
    movementBy2: null,
    movementDate: moment().format(formats.dateFormat),
    remarks: null,
    approvalStatus: null,
    fileInput1: null,
    fileInput2: null,
    fileInput3: null,
    fileInput4: null,
    fileInput5: null,
    movementDetails: [],
  }

  const CREATE_GOODS_MOVEMENT_FORM_ID = 'CreateGoodsMovementForm';

  let applicationDetailInfo = structuredClone(DEFAULT_MOVEMENT_DETAIL_INFO);
  let fileInputs = {
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
  }

  let isUploadDialogOpen = false;

  const handleCloseUploadDialogClick = () => {
    isUploadDialogOpen = false;
  }

  const buildCreateApplicationBody = () => {
    const payload = {
      movementBy: applicationDetailInfo.movementBy,
      movementBy2: applicationDetailInfo.movementBy2,
      movementDate: moment(applicationDetailInfo.movementDate).format(formats.apiDateFormat),
      remarks: applicationDetailInfo.remarks,
      approvalStatus: applicationDetailInfo.approvalStatus,
      fileInput1: fileInputs[1],
      fileInput2: fileInputs[2],
      fileInput3: fileInputs[3],
      fileInput4: fileInputs[4],
      fileInput5: fileInputs[5],
      movementDetails: applicationDetailInfo.movementDetails,
    }

    let payloadFormData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (!value) {
        return
      }
      if (key == 'movementDetails') {
        value.forEach((item, index) => {
          payloadFormData.append(`movementDetails[${index}].ChannelCode`, item.channelCode);
          payloadFormData.append(`movementDetails[${index}].StorageId`, applicationDetailInfo.Storage.code);
          payloadFormData.append(`movementDetails[${index}].QTY`, item.uploadQty);
          payloadFormData.append(`movementDetails[${index}].GoodsControlId`, item.goodsControlId);
        })
      } else payloadFormData.append(key, value)
    })

    return payloadFormData
  }
  const manualValidate = () => {
    if (!applicationDetailInfo.movementDetails.length) {
      this.showErrorMessage(this.getText('EM00000833', 'There is no data to upload! Please upload Retail Qty.'))
      return false
    }
    return true
  }

  let lastButtonClick = '';

  const onSubmitButtonsClick = (e) => {
    lastButtonClick = e.target.name;
  }

  const handleSubmit = (e, onClose) => {
    if (!this.validateForm(e)) {
      return
    }
    if (!manualValidate()) {
      return
    }
    if (lastButtonClick === ACTIONS.SUBMIT) {
      handleChange({ approvalStatus: APPROVAL_STATUSES.PendingApproval.code })
    } else handleChange({ approvalStatus: APPROVAL_STATUSES.PendingSubmission.code })

    const payload = buildCreateApplicationBody()

    this.showLoading();

    saveApplication(payload)
      .then((result) => {
        if (result.transStatus === 'SUCCESS') {
          this.showMessage(this.getText("LT00001018", "Item added successfully"), this.getText('EM00000004', 'Success'), () => onClose(true))
        } else this.showErrorMessage(result.message ?? result.code, this.getText("EM00000142", "Error"))
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const downloadProofFile = (fileId, fileName) => {
    goodMovementModel.downloadProofFile(fileId, fileName)
  }

  const handleChange = (newItem) => {
    applicationDetailInfo = { ...applicationDetailInfo, ...newItem }
  }

  const handleConfirmClick = (resultTableData) => {
    handleChange({ movementDetails: resultTableData })
  }

  return {
    oninit: ({ attrs: { selectedWarehouseStorageItem } }) => {
      handleChange({
        Warehouse: selectedWarehouseStorageItem.warehouse,
        Storage: selectedWarehouseStorageItem.storageLocation,
        Applicant: loginModel.credentials.username
      })
    },
    view: ({ attrs: { isOpen, onClose } }) => {
      return [m(Dialog, {
        isOpen,
        onClose,
        closeOnOutsideClick: false,
        closeOnEscapeKey: false,
        class: 'cui-dialog-xxl',
        title: this.getText('LT00001309', 'Goods Issue Application'),
        content: [
          m('.card',
            m('.card-body',
              m('form.needs-validation[novalidate]', {
                id: CREATE_GOODS_MOVEMENT_FORM_ID,
                onsubmit: (e) => { handleSubmit(e, onClose) }
              },
                m('.row.g-2',
                  m('.col-md-4',
                    m('label.form-label[for="warehouse"]',
                      this.getText('LT00001269', 'Warehouse')
                    ),
                    m(`input#warehouse.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.Warehouse.name,
                        title: applicationDetailInfo.Warehouse.name
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="storageLocation"]',
                      this.getText('LT00001270', 'Storage Location')
                    ),
                    m(`input#storageLocation.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.Storage.name,
                        title: applicationDetailInfo.Storage.name
                      }
                    )
                  ),

                  m('.col-md-4'),
                  m('.col-md-4',
                    m('label.form-label[for="Applicant"]',
                      this.getText('LT00001316', 'Applicant')
                    ),
                    m(`input#Applicant.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.Applicant,
                        title: applicationDetailInfo.Applicant
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="ApplicationDate"]',
                      this.getText('LT00001317', 'Application Date')
                    ),
                    m(`input#ApplicationDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: moment(applicationDetailInfo.ApplicationDate).format(formats.dateFormat),
                      }
                    )
                  ),
                  m('.col-md-4.position-relative',
                    m('label.form-label.mandatory[for="movementDate"]',
                      this.getText('LT00001256', 'Goods Issue Date')
                    ),
                    m(DatePickerComponent, {
                      class: 'form-control',
                      required: true,
                      readonly: true,
                      date: moment(applicationDetailInfo.movementDate).format(formats.dateFormat),
                      onselect: (e) => {
                        handleChange({ movementDate: moment(e.detail.date).toISOString() });
                      }
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                  ),
                  m('.col-md-4.position-relative',
                    m('label.form-label.mandatory[for="approveBy"]',
                      this.getText('LT00001323', 'Approve By')
                    ),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      required: true,
                      multiple: false,
                      onSelect: (selectedUserList) => {
                        handleChange({ movementBy: selectedUserList[0].userID, movementByName: selectedUserList[0].userName })
                      },
                      selectedUserList: [{
                        userID: applicationDetailInfo.movementBy,
                        userName: applicationDetailInfo.movementByName
                      }],
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                  ),
                  m('.col-md-4.position-relative',
                    m('label.form-label[for="approveBy2"]',
                      this.getText('LT00001324', 'Approve By 2')
                    ),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      multiple: false,
                      onSelect: (selectedUserList) => {
                        handleChange({ movementBy2: selectedUserList[0].userID, movementByName2: selectedUserList[0].userName })
                      },
                      selectedUserList: [{
                        userID: applicationDetailInfo.movementBy2,
                        userName: applicationDetailInfo.movementByName2
                      }],
                    })
                  ),
                  m('.col-md-8.position-relative',
                    m('label.form-label.[for="fileInput1"]',
                      this.getText('LT00001248', 'Proof 1')
                    ),
                    m(FileUploadInputComponent, {
                      disabled: applicationDetailInfo.fileId1,
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      onInput: (uploadedFile) => {
                        fileInputs[1] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId1 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName1,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId1, applicationDetailInfo.fileName1)
                        }
                      }, applicationDetailInfo.fileName1),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId1: null, fileName1: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]

                  ),
                  m('.col-md-8',
                    m('label.form-label[for="fileInput2"]',
                      this.getText('LT00001249', 'Proof 2')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: applicationDetailInfo.fileId2,
                      onInput: (uploadedFile) => {
                        fileInputs[2] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId2 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName2,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId2, applicationDetailInfo.fileName2)
                        }
                      }, applicationDetailInfo.fileName2),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId2: null, fileName2: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]

                  ),
                  m('.col-md-8',
                    m('label.form-label[for="fileInput3"]',
                      this.getText('LT00001250', 'Proof 3')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: applicationDetailInfo.fileId3,
                      onInput: (uploadedFile) => {
                        fileInputs[3] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId3 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName3,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId3, applicationDetailInfo.fileName3)
                        }
                      }, applicationDetailInfo.fileName3),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId3: null, fileName3: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]

                  ),
                  m('.col-md-8',
                    m('label.form-label[for="fileInput4"]',
                      this.getText('LT00001251', 'Proof 4')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: applicationDetailInfo.fileId4,
                      onInput: (uploadedFile) => {
                        fileInputs[4] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId4 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName4,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId4, applicationDetailInfo.fileName4)
                        }
                      }, applicationDetailInfo.fileName4),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId4: null, fileName4: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]

                  ),
                  m('.col-md-8',
                    m('label.form-label[for="fileInput5"]',
                      this.getText('LT00001252', 'Proof 5')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: applicationDetailInfo.fileId5,
                      onInput: (uploadedFile) => {
                        fileInputs[5] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId5 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName5,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId5, applicationDetailInfo.fileName5)
                        }
                      }, applicationDetailInfo.fileName5),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId5: null, fileName5: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]

                  ),
                  m('.col-md-8',
                    m('label.form-label[for="remarks"]',
                      this.getText('LT00000152', 'Remarks')
                    ),
                    m(`textarea#remarks.form-control.form-control-bg`,
                      {
                        placeholder: this.getText('LT00000152', 'Remarks'),
                        maxlength: 1000,
                        value: applicationDetailInfo.remarks,
                        onchange: (e) => { handleChange({ remarks: e.target.value }) }
                      }
                    )
                  ),
                  m('.col-md-2.offset-md-2.align-self-end',
                    m('button.btn.btn-white', {
                      type: 'button',
                      onclick: () => { isUploadDialogOpen = true }
                    },
                      m("i.bi.bi-file-earmark-arrow-up-fill"),
                      this.getText("LT00000197", "Excel Upload")
                    )
                  ),
                  m('.col-12',
                    m('.table-responsive',
                      m('table.table.table-hover.table-bordered',
                        m('thead',
                          m('tr.align-middle',
                            m('th[scope="col"]', this.getText('LT00000721', 'No.')),
                            m('th[scope="col"]', this.getText('LT00001272', 'Control No')),
                            m('th[scope="col"]', this.getText('LT00001268', 'Basic Model')),
                            m('th[scope="col"]', this.getText('LT00001244', 'Retail Code')),
                            m('th[scope="col"]', this.getText('LT00001245', 'Retail')),
                            m('th[scope="col"]', this.getText('LT00001265', 'Upload Qty')),
                            m('th[scope="col"]', this.getText('LT00001273', 'Total Qty')),
                            m('th[scope="col"]', this.getText('LT00001277', 'Storage Qty')),
                            m('th[scope="col"]', this.getText('LT00001260', 'Retail Qty')),
                            m('th[scope="col"]', this.getText('LT00000135', 'Delete'))
                          )
                        ),
                        m('tbody',
                          (applicationDetailInfo.movementDetails.length == 0) &&
                          m('tr.align-middle',
                            m('td[colSpan=10]', this.getText("EM00000141", "No records found."))
                          ),
                          applicationDetailInfo.movementDetails.length > 0 &&
                          applicationDetailInfo.movementDetails.map((data, index) =>
                            m('tr.align-middle',
                              m('td', m('span.cursor-text', index + 1)),
                              m('td', m('span.cursor-text', data.goodsControlId)),
                              m('td', m('span.cursor-text', data.goodsName)),
                              m('td', m('span.cursor-text', data.channelCode)),
                              m('td', m('span.cursor-text', data.channelName)),
                              m('td', m('span.cursor-text', data.uploadQty)),
                              m('td', m('span.cursor-text', data.totalQty)),
                              m('td', m('span.cursor-text', data.storageQty)),
                              m('td', m('span.cursor-text', data.stockQty)),
                              m('td', m('span.cursor-text',
                                m(Icon, {
                                  class: 'py-3',
                                  intent: Intent.NEGATIVE,
                                  name: Icons.X,
                                  onclick: () => {
                                    applicationDetailInfo.movementDetails.splice(index, 1)
                                  },
                                  size: 'lg',
                                }))
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                )
              )
            )
          ),
          this.getBaseViews()
        ],

        footer: m('.row',
          m('.col-12.gap-2.d-flex.justify-content-end',
            m('button.btn.btn-primary',
              {
                type: 'submit',
                name: ACTIONS.SAVE,
                value: ACTIONS.SAVE,
                onclick: onSubmitButtonsClick,
                form: CREATE_GOODS_MOVEMENT_FORM_ID
              },
              m("i.bi.bi-floppy-fill"),
              this.getText('LT00000022', 'Save')
            ),
            m('button.btn.btn-primary',
              {
                type: 'submit',
                name: ACTIONS.SUBMIT,
                value: ACTIONS.SUBMIT,
                onclick: onSubmitButtonsClick,
                form: CREATE_GOODS_MOVEMENT_FORM_ID
              },
              m("i.bi.bi-pencil-square"),
              this.getText('LT00000005', 'Submit')
            ),
            m('button.btn.btn-white',
              {
                type: 'button',
                onclick: onClose,
              },
              this.getText('LT00000021', 'Close')
            )
          )
        ),
      }),
      isUploadDialogOpen &&
      m(RetailQtyExcelUpload, {
        isOpen: isUploadDialogOpen,
        onClose: handleCloseUploadDialogClick,
        warehouseStorage: { warehouse: applicationDetailInfo.Warehouse, storageLocation: applicationDetailInfo.Storage },
        handleConfirmClick
      })
      ]
    }
  }
}
export default CreatePOSMGoodsIssueApplicationDialog